var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5F5"
    },
    d: "M0,116.556v338.03c0,5.611,4.549,10.16,10.16,10.16H501.84c5.611,0,10.16-4.549,10.16-10.16v-338.03 H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFE2DD"
    },
    d: "M484.185,116.556v338.032c0,5.615-4.543,10.157-10.157,10.157h27.815 c5.604,0,10.157-4.543,10.157-10.157V116.556H484.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB54E"
    },
    d: "M512,67.569v56.567H0V67.569c0-11.219,9.097-20.315,20.315-20.315h471.37 C502.903,47.254,512,56.351,512,67.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9A1B"
    },
    d: "M512,67.569v56.567h-27.815V67.569c0-11.219-9.097-20.315-20.315-20.315h27.815 C502.903,47.254,512,56.351,512,67.569z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8EC737"
    },
    d: "M356.364,268.238c-6.437-0.398-11.578-11.007-14.678-24.811 c-2.609-11.651-3.775-25.572-3.037-37.583c1.621-26.251,11.71-33.366,23.579-32.637c11.528,0.714,20.489,8.586,19.495,33.134 c-0.02,0.704-0.061,1.417-0.107,2.153C379.993,234.731,368.233,268.966,356.364,268.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83B832"
    },
    d: "M356.364,268.238c-6.437-0.398-11.578-11.007-14.678-24.811 c2.381-3.794,5.465-7.745,9.24-11.838c8.405-9.126,19.637-18.299,30.798-25.248c-0.02,0.704-0.061,1.417-0.107,2.153 C379.993,234.731,368.233,268.966,356.364,268.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDEB73"
    },
    d: "M393.811,216.134c-22.913,12.893-48.6,38.405-42.771,48.765 c5.829,10.359,40.968,1.643,63.881-11.25s24.923-25.082,19.094-35.441C428.186,207.848,416.724,203.241,393.811,216.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AD63B"
    },
    d: "M414.921,253.652c-22.912,12.886-58.046,21.608-63.884,11.244 c-1.364-2.409-1.004-5.641,0.624-9.347c13.418,1.28,37.417-6.031,54.566-15.678c18.064-10.17,23.135-19.891,21.616-28.629 c2.561,1.727,4.582,4.131,6.176,6.963C439.842,228.571,437.832,240.752,414.921,253.652z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8EC737"
    },
    d: "M155.636,268.237c6.437-0.398,11.578-11.007,14.678-24.811 c2.609-11.651,3.775-25.572,3.037-37.583c-1.621-26.251-11.71-33.366-23.579-32.638c-11.528,0.714-20.489,8.586-19.495,33.134 c0.02,0.704,0.061,1.417,0.107,2.153C132.007,234.731,143.767,268.966,155.636,268.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83B832"
    },
    d: "M173.351,205.844c0.738,12.01-0.428,25.932-3.037,37.583 c-3.1,13.804-8.242,24.413-14.678,24.811c-1.746,0.106-3.507-0.551-5.215-1.824c2.116-4.25,3.899-9.757,5.279-15.89 c2.609-11.651,3.775-25.572,3.037-37.583c-1.592-25.827-11.391-33.131-23.001-32.661c3.526-4.726,8.491-6.731,14.036-7.074 C161.641,172.478,171.73,179.593,173.351,205.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83B832"
    },
    d: "M155.636,268.237c6.437-0.398,11.578-11.007,14.678-24.811 c-2.381-3.794-5.465-7.745-9.24-11.838c-8.405-9.126-19.637-18.299-30.798-25.248c0.02,0.704,0.061,1.417,0.107,2.153 C132.007,234.731,143.767,268.966,155.636,268.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDEB73"
    },
    d: "M118.189,216.134c22.913,12.893,48.6,38.405,42.771,48.765 c-5.829,10.359-40.968,1.643-63.881-11.25c-22.913-12.893-24.923-25.082-19.094-35.441S95.276,203.24,118.189,216.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AD63B"
    },
    d: "M160.962,264.897c-1.47,2.607-4.793,4.009-9.318,4.433 c-4.962-12.232-24.529-29.978-42.403-40.036c-16.297-9.166-26.788-9.485-33.589-5.179c0.444-2.031,1.252-4.001,2.328-5.91 c5.829-10.357,17.299-14.964,40.203-2.071C141.103,229.029,166.792,254.54,160.962,264.897z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8EC737"
    },
    d: "M356.364,314.211c-6.437,0.398-11.578,11.007-14.678,24.811 c-2.609,11.651-3.775,25.572-3.037,37.583c1.621,26.251,11.71,33.366,23.579,32.637c11.528-0.714,20.489-8.586,19.495-33.134 c-0.02-0.704-0.061-1.417-0.107-2.153C379.993,347.717,368.233,313.482,356.364,314.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83B832"
    },
    d: "M356.364,314.211c-6.437,0.398-11.578,11.007-14.678,24.811 c2.381,3.794,5.465,7.745,9.24,11.838c8.405,9.126,19.637,18.299,30.798,25.248c-0.02-0.704-0.061-1.417-0.107-2.153 C379.993,347.717,368.233,313.482,356.364,314.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDEB73"
    },
    d: "M393.811,366.314c-22.913-12.893-48.6-38.405-42.771-48.765s40.968-1.643,63.881,11.25 c22.913,12.893,24.923,25.082,19.094,35.441S416.724,379.207,393.811,366.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AD63B"
    },
    d: "M414.921,328.796c-22.912-12.886-58.046-21.608-63.884-11.244 c-1.364,2.409-1.004,5.641,0.624,9.347c13.418-1.28,37.417,6.031,54.566,15.678c18.064,10.17,23.135,19.891,21.616,28.629 c2.561-1.727,4.582-4.131,6.176-6.963C439.842,353.878,437.832,341.697,414.921,328.796z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8EC737"
    },
    d: "M155.636,314.211c6.437,0.398,11.578,11.007,14.678,24.811 c2.609,11.651,3.775,25.572,3.037,37.583c-1.621,26.251-11.71,33.366-23.579,32.638c-11.528-0.714-20.489-8.586-19.495-33.134 c0.02-0.704,0.061-1.417,0.107-2.153C132.007,347.718,143.767,313.482,155.636,314.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83B832"
    },
    d: "M173.351,376.604c0.738-12.01-0.428-25.932-3.037-37.583 c-3.1-13.804-8.242-24.413-14.678-24.811c-1.746-0.106-3.507,0.551-5.215,1.824c2.116,4.25,3.899,9.757,5.279,15.89 c2.609,11.651,3.775,25.572,3.037,37.583c-1.592,25.827-11.391,33.131-23.001,32.661c3.526,4.726,8.491,6.731,14.036,7.074 C161.641,409.97,171.73,402.856,173.351,376.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83B832"
    },
    d: "M155.636,314.211c6.437,0.398,11.578,11.007,14.678,24.811 c-2.381,3.794-5.465,7.745-9.24,11.838c-8.405,9.126-19.637,18.299-30.798,25.248c0.02-0.704,0.061-1.417,0.107-2.153 C132.007,347.718,143.767,313.482,155.636,314.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDEB73"
    },
    d: "M118.189,366.314c22.913-12.893,48.6-38.405,42.771-48.765 c-5.829-10.359-40.968-1.643-63.881,11.25s-24.923,25.082-19.094,35.441C83.814,374.6,95.276,379.208,118.189,366.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AD63B"
    },
    d: "M160.962,317.552c-1.47-2.607-4.793-4.009-9.318-4.433 c-4.962,12.232-24.529,29.978-42.403,40.036c-16.297,9.166-26.788,9.485-33.589,5.178c0.444,2.031,1.252,4.001,2.328,5.91 c5.829,10.357,17.299,14.964,40.203,2.071C141.103,353.419,166.792,327.908,160.962,317.552z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED6264"
    },
    d: "M457.256,326.444H341.773c-5.316,0-9.622-4.306-9.622-9.612V256h126.228 c8.705,0,12.929,10.652,6.593,16.617l-20.892,19.677l19.563,17.338C470.267,315.503,466.116,326.444,457.256,326.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E84649"
    },
    d: "M384.185,291.222c0,12.208-1.72,24.024-4.924,35.222h-37.488c-5.316,0-9.622-4.306-9.622-9.612 V256h47.11C382.465,267.198,384.185,279.014,384.185,291.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED6264"
    },
    d: "M179.849,256v60.832c0,5.305-4.306,9.612-9.622,9.612H54.744c-8.86,0-13.011-10.941-6.387-16.813 l19.563-17.338l-20.892-19.677C40.692,266.652,44.916,256,53.621,256H179.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E84649"
    },
    d: "M132.739,256h47.11v60.832c0,5.305-4.306,9.612-9.622,9.612h-37.488 c-3.204-11.198-4.924-23.014-4.924-35.222C127.815,279.014,129.535,267.198,132.739,256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFCE8B"
    },
    cx: 256,
    cy: 291.224,
    r: 113.763
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB54E"
    },
    cx: 256,
    cy: 291.224,
    r: 97.795
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65BAFC"
    },
    cx: 256,
    cy: 291.224,
    r: 84.478
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2EA8FC"
    },
    d: "M340.473,291.224c0,46.66-37.813,84.473-84.473,84.473c-3.463,0-6.878-0.209-10.226-0.618 c41.837-5.042,74.247-40.658,74.247-83.855s-32.41-78.813-74.247-83.855c3.349-0.409,6.764-0.618,10.226-0.618 C302.66,206.751,340.473,244.564,340.473,291.224z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE8B"
    },
    d: "M300.596,283.681l-18.845,18.369l4.442,25.941c0.666,3.881-3.406,6.849-6.897,5.013L256,320.752 l-23.297,12.253c-3.491,1.836-7.563-1.132-6.897-5.013l2.093-12.234l2.35-13.708l-18.845-18.369 c-2.816-2.749-1.265-7.544,2.635-8.114l26.046-3.786l11.653-23.601c1.741-3.529,6.783-3.529,8.523,0l11.653,23.601 l10.968,1.598l15.078,2.188C301.861,276.138,303.412,280.932,300.596,283.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB54E"
    },
    d: "M300.596,283.681l-18.845,18.369l4.442,25.941c0.666,3.881-3.406,6.849-6.897,5.013L256,320.752 l-23.297,12.253c-3.491,1.836-7.563-1.132-6.897-5.013l2.093-12.234c34.95-9.674,49.219-29.28,54.984-42.379l15.078,2.188 C301.861,276.138,303.412,280.932,300.596,283.681z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5F5"
    },
    d: "M52.469,93.957c-4.268,0-7.726-3.459-7.726-7.726c0-4.268,3.459-7.742,7.726-7.742 s7.726,3.444,7.726,7.711v0.031C60.195,90.498,56.736,93.957,52.469,93.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5F5"
    },
    d: "M81.314,93.957c-4.268,0-7.726-3.459-7.726-7.726c0-4.268,3.459-7.742,7.726-7.742 c4.268,0,7.726,3.444,7.726,7.711v0.031C89.04,90.498,85.581,93.957,81.314,93.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5F5"
    },
    d: "M110.159,93.957c-4.268,0-7.726-3.459-7.726-7.726c0-4.268,3.459-7.742,7.726-7.742 c4.268,0,7.726,3.444,7.726,7.711v0.031C117.885,90.498,114.427,93.957,110.159,93.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9A1B"
    },
    d: "M459.531,93.957H235.514c-4.268,0-7.726-3.459-7.726-7.726c0-4.268,3.459-7.726,7.726-7.726 h224.017c4.268,0,7.726,3.459,7.726,7.726C467.258,90.498,463.799,93.957,459.531,93.957z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphics);
export default __webpack_public_path__ + "static/media/graphics.edcaa557f3703e4f9cfd2517e48865b7.svg";
export { ForwardRef as ReactComponent };